import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.to-string.js";
import { useTrpc } from '~/composables/_next/useTrpc';
import { useStoreCustomer } from '~/composables/_next/stores/useStoreCustomer';
import { useNuxt2App } from '~/composables/useNuxt2App';
import { klaviyoProfileUpdateEvent } from '~/helpers/tracking/klaviyo';
import { useLocalization } from '~/composables/_next/useLocalization';
export function useUser() {
  var _useNuxt2App = useNuxt2App(),
    $sentry = _useNuxt2App.$sentry;
  var _useLocalization = useLocalization(),
    locale = _useLocalization.locale;
  var utmCampaign = useCookie('utm_campaign');
  var utmSource = useCookie('utm_source');
  var utmMedium = useCookie('utm_medium');
  var utmContent = useCookie('utm_content');
  var utmTerm = useCookie('utm_term');
  var _useTrpc = useTrpc(),
    client = _useTrpc.client;
  var _useStoreCustomer = useStoreCustomer(),
    user = _useStoreCustomer.user,
    setUser = _useStoreCustomer.setUser,
    setCart = _useStoreCustomer.setCart;
  var getDefaultUserError = function getDefaultUserError() {
    return {
      updateUser: null,
      register: null,
      login: null,
      logout: null,
      changePassword: null,
      load: null
    };
  };
  var loading = useState('useUser-loading', function () {
    return false;
  });
  var error = useState('useUser-error', getDefaultUserError);
  var isAuthenticated = computed(function () {
    return !!user.value;
  });
  function load() {
    return _load.apply(this, arguments);
  }
  function _load() {
    _load = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var customer, cart;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            error.value = getDefaultUserError();
            _context.prev = 1;
            loading.value = true;
            _context.next = 5;
            return client.customer.getCustomerFullProfile.query();
          case 5:
            customer = _context.sent;
            if (!customer || _typeof(customer) !== 'object') {
              setUser(null);
            } else {
              setUser(customer);
            }

            // TODO: move this to useCart
            _context.prev = 7;
            _context.next = 10;
            return client.cart.getActiveCartFull.query({
              customerGroupValue: process.env.CUSTOMER_GROUP_WITHOUT_VAT
            });
          case 10:
            cart = _context.sent;
            setCart(cart);
            _context.next = 17;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](7);
            console.error(_context.t0);
          case 17:
            return _context.abrupt("return", user.value);
          case 20:
            _context.prev = 20;
            _context.t1 = _context["catch"](1);
            error.value.load = _context.t1;
            console.error(_context.t1);
          case 24:
            _context.prev = 24;
            loading.value = false;
            return _context.finish(24);
          case 27:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 20, 24, 27], [7, 14]]);
    }));
    return _load.apply(this, arguments);
  }
  function update(_x) {
    return _update.apply(this, arguments);
  }
  /**
   * Register a new user.
   *
   * @param user
   * @param buyapowaDecryptedData - deprecated, but kept for backward compatibility
   * @returns
   */
  function _update() {
    _update = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(fields) {
      var customer;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            error.value = getDefaultUserError();
            _context2.prev = 1;
            loading.value = true;
            _context2.next = 5;
            return client.customer.updateCustomer.mutate(fields);
          case 5:
            customer = _context2.sent;
            setUser(customer);
            error.value.updateUser = null;
            _context2.next = 13;
            break;
          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](1);
            error.value.updateUser = _context2.t0;
          case 13:
            _context2.prev = 13;
            loading.value = false;
            return _context2.finish(13);
          case 16:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 10, 13, 16]]);
    }));
    return _update.apply(this, arguments);
  }
  function register(_x2) {
    return _register.apply(this, arguments);
  }
  function _register() {
    _register = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(user) {
      var buyapowaDecryptedData,
        _utmCampaign$value,
        _utmSource$value,
        _utmMedium$value,
        _utmContent$value,
        _utmTerm$value,
        _args3 = arguments;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            buyapowaDecryptedData = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : null;
            error.value = getDefaultUserError();
            _context3.prev = 2;
            loading.value = true;
            _context3.next = 6;
            return client.customer.signup.mutate(_objectSpread(_objectSpread({}, user), {}, {
              locale: locale,
              utm: {
                campaign: (_utmCampaign$value = utmCampaign.value) === null || _utmCampaign$value === void 0 ? void 0 : _utmCampaign$value.toString(),
                source: (_utmSource$value = utmSource.value) === null || _utmSource$value === void 0 ? void 0 : _utmSource$value.toString(),
                medium: (_utmMedium$value = utmMedium.value) === null || _utmMedium$value === void 0 ? void 0 : _utmMedium$value.toString(),
                content: (_utmContent$value = utmContent.value) === null || _utmContent$value === void 0 ? void 0 : _utmContent$value.toString(),
                term: (_utmTerm$value = utmTerm.value) === null || _utmTerm$value === void 0 ? void 0 : _utmTerm$value.toString()
              },
              buyapowaEmail: buyapowaDecryptedData === null || buyapowaDecryptedData === void 0 ? void 0 : buyapowaDecryptedData.email
            }));
          case 6:
            error.value.register = null;
            _context3.next = 12;
            break;
          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](2);
            error.value.register = _context3.t0.message;
          case 12:
            _context3.prev = 12;
            loading.value = false;
            return _context3.finish(12);
          case 15:
            if (!error.value.register) {
              _context3.next = 17;
              break;
            }
            return _context3.abrupt("return");
          case 17:
            _context3.prev = 17;
            _context3.next = 20;
            return load();
          case 20:
            _context3.next = 27;
            break;
          case 22:
            _context3.prev = 22;
            _context3.t1 = _context3["catch"](17);
            $sentry === null || $sentry === void 0 ? void 0 : $sentry.setContext('signup', {
              email: user.email,
              locale: locale,
              error: error
            });
            $sentry === null || $sentry === void 0 ? void 0 : $sentry.captureException(new Error('Load user profile after signup failed'));
            throw _context3.t1;
          case 27:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[2, 9, 12, 15], [17, 22]]);
    }));
    return _register.apply(this, arguments);
  }
  function login(_x3) {
    return _login.apply(this, arguments);
  }
  function _login() {
    _login = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref) {
      var email, password;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            email = _ref.email, password = _ref.password;
            error.value = getDefaultUserError();
            _context4.prev = 2;
            loading.value = true;
            _context4.next = 6;
            return client.customer.login.mutate({
              email: email,
              password: password
            });
          case 6:
            _context4.prev = 6;
            _context4.next = 9;
            return load();
          case 9:
            _context4.next = 16;
            break;
          case 11:
            _context4.prev = 11;
            _context4.t0 = _context4["catch"](6);
            $sentry === null || $sentry === void 0 ? void 0 : $sentry.setContext('login', {
              email: email,
              locale: locale,
              error: error
            });
            $sentry === null || $sentry === void 0 ? void 0 : $sentry.captureException(new Error('Load user profile after login failed'));
            throw _context4.t0;
          case 16:
            _context4.prev = 16;
            _context4.next = 19;
            return klaviyoProfileUpdateEvent(email, locale);
          case 19:
            _context4.next = 25;
            break;
          case 21:
            _context4.prev = 21;
            _context4.t1 = _context4["catch"](16);
            $sentry === null || $sentry === void 0 ? void 0 : $sentry.setContext('login', {
              email: email,
              locale: locale,
              error: error
            });
            $sentry === null || $sentry === void 0 ? void 0 : $sentry.captureException(new Error('Klaviyo profile update on login failed'));
          case 25:
            _context4.next = 30;
            break;
          case 27:
            _context4.prev = 27;
            _context4.t2 = _context4["catch"](2);
            error.value.login = _context4.t2;
          case 30:
            _context4.prev = 30;
            loading.value = false;
            return _context4.finish(30);
          case 33:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[2, 27, 30, 33], [6, 11], [16, 21]]);
    }));
    return _login.apply(this, arguments);
  }
  function logout() {
    return _logout.apply(this, arguments);
  }
  function _logout() {
    _logout = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            if (isAuthenticated.value) {
              _context5.next = 2;
              break;
            }
            return _context5.abrupt("return");
          case 2:
            error.value = getDefaultUserError();
            _context5.prev = 3;
            setUser(null);
            setCart(null);
            _context5.next = 8;
            return client.customer.logout.mutate();
          case 8:
            error.value.logout = null;
            _context5.next = 14;
            break;
          case 11:
            _context5.prev = 11;
            _context5.t0 = _context5["catch"](3);
            error.value.logout = _context5.t0;
          case 14:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[3, 11]]);
    }));
    return _logout.apply(this, arguments);
  }
  function changePassword(_x4) {
    return _changePassword.apply(this, arguments);
  }
  function _changePassword() {
    _changePassword = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref2) {
      var currentPassword, newPassword;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            currentPassword = _ref2.currentPassword, newPassword = _ref2.newPassword;
            error.value = getDefaultUserError();
            _context6.prev = 2;
            loading.value = true;
            _context6.next = 6;
            return client.customer.changePassword.mutate({
              currentPassword: currentPassword,
              newPassword: newPassword
            });
          case 6:
            error.value.changePassword = null;
            _context6.next = 12;
            break;
          case 9:
            _context6.prev = 9;
            _context6.t0 = _context6["catch"](2);
            error.value.changePassword = _context6.t0;
          case 12:
            _context6.prev = 12;
            loading.value = false;
            return _context6.finish(12);
          case 15:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[2, 9, 12, 15]]);
    }));
    return _changePassword.apply(this, arguments);
  }
  var isIntracomGroup = computed(function () {
    var _user$value, _user$value$customerG;
    return ((_user$value = user.value) === null || _user$value === void 0 ? void 0 : (_user$value$customerG = _user$value.customerGroup) === null || _user$value$customerG === void 0 ? void 0 : _user$value$customerG.key) === process.env.CUSTOMER_GROUP_WITHOUT_VAT;
  });
  var shippingAddresses = computed(function () {
    var _user$value$shippingA, _user$value2;
    return (_user$value$shippingA = (_user$value2 = user.value) === null || _user$value2 === void 0 ? void 0 : _user$value2.shippingAddresses) !== null && _user$value$shippingA !== void 0 ? _user$value$shippingA : [];
  });
  var defaultShippingAddress = computed(function () {
    var _shippingAddresses$va;
    return (_shippingAddresses$va = shippingAddresses.value.find(function (_ref3) {
      var _user$value3;
      var id = _ref3.id;
      return id === ((_user$value3 = user.value) === null || _user$value3 === void 0 ? void 0 : _user$value3.defaultShippingAddressId);
    })) !== null && _shippingAddresses$va !== void 0 ? _shippingAddresses$va : null;
  });
  var billingAddresses = computed(function () {
    var _user$value$billingAd, _user$value4;
    return (_user$value$billingAd = (_user$value4 = user.value) === null || _user$value4 === void 0 ? void 0 : _user$value4.billingAddresses) !== null && _user$value$billingAd !== void 0 ? _user$value$billingAd : [];
  });
  var defaultBillingAddress = computed(function () {
    var _billingAddresses$val;
    return (_billingAddresses$val = billingAddresses.value.find(function (_ref4) {
      var _user$value5;
      var id = _ref4.id;
      return id === ((_user$value5 = user.value) === null || _user$value5 === void 0 ? void 0 : _user$value5.defaultBillingAddressId);
    })) !== null && _billingAddresses$val !== void 0 ? _billingAddresses$val : null;
  });
  var isNewAddressVerified = useState('checkout-user-store-is-new-address-verified', function () {
    return false;
  });
  function addShippingAddress(_x5) {
    return _addShippingAddress.apply(this, arguments);
  }
  function _addShippingAddress() {
    _addShippingAddress = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(_ref5) {
      var _location$lat, _location$lng;
      var address, location, isDefault, updatedUser;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            address = _ref5.address, location = _ref5.location, isDefault = _ref5.isDefault;
            _context7.next = 3;
            return client.customer.addShippingAddress.mutate({
              address: address,
              location: {
                lat: (_location$lat = location === null || location === void 0 ? void 0 : location.lat) !== null && _location$lat !== void 0 ? _location$lat : 0,
                lng: (_location$lng = location === null || location === void 0 ? void 0 : location.lng) !== null && _location$lng !== void 0 ? _location$lng : 0
              },
              isDefault: isDefault,
              isVerified: isNewAddressVerified.value
            });
          case 3:
            updatedUser = _context7.sent;
            updatedUser && setUser(updatedUser);
          case 5:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return _addShippingAddress.apply(this, arguments);
  }
  function updateShippingAddress(_x6) {
    return _updateShippingAddress.apply(this, arguments);
  }
  function _updateShippingAddress() {
    _updateShippingAddress = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8(_ref6) {
      var _location$lat2, _location$lng2;
      var address, location, updatedUser;
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            address = _ref6.address, location = _ref6.location;
            _context8.next = 3;
            return client.customer.updateShippingAddress.mutate({
              address: address,
              location: {
                lat: (_location$lat2 = location === null || location === void 0 ? void 0 : location.lat) !== null && _location$lat2 !== void 0 ? _location$lat2 : 0,
                lng: (_location$lng2 = location === null || location === void 0 ? void 0 : location.lng) !== null && _location$lng2 !== void 0 ? _location$lng2 : 0
              },
              isVerified: isNewAddressVerified.value
            });
          case 3:
            updatedUser = _context8.sent;
            updatedUser && setUser(updatedUser);
          case 5:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return _updateShippingAddress.apply(this, arguments);
  }
  function removeShippingAddress(_x7) {
    return _removeShippingAddress.apply(this, arguments);
  }
  function _removeShippingAddress() {
    _removeShippingAddress = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee9(addressId) {
      var updatedUser;
      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return client.customer.removeShippingAddress.mutate({
              addressId: addressId
            });
          case 2:
            updatedUser = _context9.sent;
            setUser(updatedUser);
          case 4:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
    return _removeShippingAddress.apply(this, arguments);
  }
  function setDefaultShippingAddress(_x8) {
    return _setDefaultShippingAddress.apply(this, arguments);
  }
  function _setDefaultShippingAddress() {
    _setDefaultShippingAddress = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee0(address) {
      var updatedUser;
      return regeneratorRuntime.wrap(function _callee0$(_context0) {
        while (1) switch (_context0.prev = _context0.next) {
          case 0:
            _context0.next = 2;
            return client.customer.setDefaultShippingAddress.mutate({
              addressId: address.id
            });
          case 2:
            updatedUser = _context0.sent;
            updatedUser && setUser(updatedUser);
            if (user.value.firstName && user.value.lastName) {
              _context0.next = 7;
              break;
            }
            _context0.next = 7;
            return update(_objectSpread(_objectSpread({}, user.value), {}, {
              firstName: address.firstName,
              lastName: address.lastName
            }));
          case 7:
          case "end":
            return _context0.stop();
        }
      }, _callee0);
    }));
    return _setDefaultShippingAddress.apply(this, arguments);
  }
  function addBillingAddress(_x9) {
    return _addBillingAddress.apply(this, arguments);
  }
  function _addBillingAddress() {
    _addBillingAddress = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee1(_ref7) {
      var address, isDefault, updatedUser;
      return regeneratorRuntime.wrap(function _callee1$(_context1) {
        while (1) switch (_context1.prev = _context1.next) {
          case 0:
            address = _ref7.address, isDefault = _ref7.isDefault;
            _context1.next = 3;
            return client.customer.addBillingAddress.mutate({
              address: address,
              isDefault: isDefault
            });
          case 3:
            updatedUser = _context1.sent;
            updatedUser && setUser(updatedUser);
          case 5:
          case "end":
            return _context1.stop();
        }
      }, _callee1);
    }));
    return _addBillingAddress.apply(this, arguments);
  }
  function updateBillingAddress(_x0) {
    return _updateBillingAddress.apply(this, arguments);
  }
  function _updateBillingAddress() {
    _updateBillingAddress = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee10(_ref8) {
      var address, updatedUser;
      return regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            address = _ref8.address;
            _context10.next = 3;
            return client.customer.updateBillingAddress.mutate({
              defaultBillingAddressId: user.value.defaultBillingAddressId,
              address: address
            });
          case 3:
            updatedUser = _context10.sent;
            updatedUser && setUser(updatedUser);
          case 5:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }));
    return _updateBillingAddress.apply(this, arguments);
  }
  function removeBillingAddress(_x1) {
    return _removeBillingAddress.apply(this, arguments);
  }
  function _removeBillingAddress() {
    _removeBillingAddress = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee11(addressId) {
      var updatedUser;
      return regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 2;
            return client.customer.removeBillingAddress.mutate({
              addressId: addressId
            });
          case 2:
            updatedUser = _context11.sent;
            updatedUser && setUser(updatedUser);
          case 4:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    }));
    return _removeBillingAddress.apply(this, arguments);
  }
  function setDefaultBillingAddress(_x10) {
    return _setDefaultBillingAddress.apply(this, arguments);
  }
  function _setDefaultBillingAddress() {
    _setDefaultBillingAddress = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee12(address) {
      var updatedUser;
      return regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return client.customer.setDefaultBillingAddress.mutate({
              addressId: address.id
            });
          case 2:
            updatedUser = _context12.sent;
            updatedUser && setUser(updatedUser);
            if (user.value.firstName && user.value.lastName) {
              _context12.next = 7;
              break;
            }
            _context12.next = 7;
            return update(_objectSpread(_objectSpread({}, user.value), {}, {
              firstName: address.firstName,
              lastName: address.lastName
            }));
          case 7:
          case "end":
            return _context12.stop();
        }
      }, _callee12);
    }));
    return _setDefaultBillingAddress.apply(this, arguments);
  }
  return {
    user: user,
    isAuthenticated: isAuthenticated,
    loading: readonly(loading),
    error: readonly(error),
    load: load,
    update: update,
    register: register,
    login: login,
    logout: logout,
    changePassword: changePassword,
    isNewAddressVerified: isNewAddressVerified,
    isIntracomGroup: isIntracomGroup,
    shippingAddresses: shippingAddresses,
    billingAddresses: billingAddresses,
    defaultShippingAddress: defaultShippingAddress,
    defaultBillingAddress: defaultBillingAddress,
    addShippingAddress: addShippingAddress,
    updateShippingAddress: updateShippingAddress,
    removeShippingAddress: removeShippingAddress,
    setDefaultShippingAddress: setDefaultShippingAddress,
    addBillingAddress: addBillingAddress,
    updateBillingAddress: updateBillingAddress,
    removeBillingAddress: removeBillingAddress,
    setDefaultBillingAddress: setDefaultBillingAddress
  };
}